import { Color } from "@lux/wardrobe-lib";

export enum statusPhoto {
    PUBLISHED = 'published',
    SAVED = 'saved',
    APPROVED = 'approved',
    TO_APPROVE = 'inApproval',
    IN_APPROVAL = 'in_approval',
    REJECTED = 'rejected',
    CANCELLED = 'cancelled'
}

export const statusIconMap = {
    [statusPhoto.PUBLISHED]: {
        icon: 'globe',
        color: Color.LIGHT_BLUE
    },
    [statusPhoto.SAVED]: {
        icon: 'arrow-down-circle',
        color: Color.LIGHT_BLUE
    },
    [statusPhoto.APPROVED]: {
        icon: 'check-circle',
        color: Color.GREEN
    },
    [statusPhoto.TO_APPROVE]: {
        icon: 'camera',
        color: Color.LIGHT_BLUE
    },
    [statusPhoto.IN_APPROVAL]: {
        icon: 'camera',
        color: Color.LIGHT_BLUE
    },
    [statusPhoto.REJECTED]: {
        icon: 'rejected',
        color: Color.RED
    },
}